var _path, _g, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTechnicalSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_446_1470",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 55,
    height: 55
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H56.5293V56.3041H2V2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_446_1470)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.3194 44.3436C20.9439 44.3436 14.1306 37.5109 14.1306 29.1159C14.1306 20.7389 20.9439 13.9242 29.3194 13.9242C37.7036 13.9242 44.5169 20.7389 44.5169 29.1159C44.5169 30.5739 44.3161 31.9872 43.9153 33.3573L49.4901 38.9336C50.1529 37.5721 50.6674 36.1761 51.0164 34.7707L55.9371 33.9071C56.2509 33.8546 56.4783 33.5754 56.4783 33.2609V25.0149C56.4783 24.7011 56.2509 24.4306 55.9371 24.3694L51.0251 23.4879C50.5192 21.5068 49.7255 19.5962 48.6525 17.7806L51.523 13.6709C51.6972 13.409 51.6713 13.06 51.4439 12.8333L45.5992 7.01307C45.3718 6.78568 45.0228 6.75977 44.7616 6.93392L40.6612 9.7879C38.8636 8.73151 36.9531 7.93778 34.9727 7.44052L34.0919 2.50111C34.0307 2.18736 33.7602 1.95996 33.4457 1.95996H25.2018C24.8873 1.95996 24.6168 2.18736 24.5563 2.50111L23.6748 7.44052C21.6944 7.93778 19.7839 8.72287 17.9776 9.7879L13.8686 6.93392C13.6074 6.75977 13.2584 6.78568 13.031 7.01307L7.20361 12.8333C6.97693 13.06 6.9503 13.409 7.12517 13.6709L9.99498 17.7806C8.92204 19.5962 8.12831 21.5068 7.62242 23.4879L2.71035 24.3694C2.3966 24.4306 2.16992 24.7011 2.16992 25.0149V33.2609C2.16992 33.5754 2.3966 33.8546 2.71035 33.9071L7.63105 34.7707C8.12831 36.7345 8.92204 38.6544 9.99498 40.4865L7.12517 44.5876C6.9503 44.8495 6.97693 45.1985 7.20361 45.4259L13.031 51.2634C13.2584 51.4901 13.6074 51.5167 13.8686 51.3419L17.9776 48.4713C19.7752 49.5184 21.6858 50.3121 23.6748 50.8187L24.5563 55.7574C24.6168 56.0719 24.8873 56.2986 25.2018 56.2986H33.4457C33.7602 56.2986 34.0307 56.0719 34.0919 55.7574L34.9727 50.8187C36.6127 50.3999 38.2009 49.7889 39.7099 48.9945L34.2488 43.5233C32.6786 44.0731 31.0292 44.3436 29.3194 44.3436Z",
    fill: "url(#paint0_linear_446_1470)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3303 47.6237L48.4959 39.7878L40.2161 31.5065C40.5039 30.4595 40.6529 29.4038 40.6529 28.3654C40.6529 24.9271 39.1086 21.6198 36.3079 19.3508C33.6734 17.2129 30.2272 16.358 26.8507 17.0035C26.2988 17.1258 26.1599 17.7612 26.5104 18.1117L31.6146 23.2166L30.5589 30.1105L23.8759 30.974L18.7544 25.8518C18.3946 25.4913 17.7678 25.6474 17.6469 26.1922C17.5073 26.9255 17.4375 27.658 17.4375 28.3913C17.4375 31.4367 18.6414 34.395 20.8398 36.5942C23.8147 39.5698 28.1072 40.6866 32.1464 39.5698C54.2406 61.6568 46.6199 54.0383 48.2685 55.6869C50.518 57.9364 54.1175 57.9083 56.339 55.6869C58.5547 53.4705 58.5547 49.8581 56.3303 47.6237ZM52.448 51.8039C51.8112 52.4321 50.7814 52.4321 50.1446 51.8039C49.5149 51.1749 49.5135 50.1488 50.1532 49.509C50.8836 48.7772 51.8975 48.9492 52.448 49.5004C53.0871 50.1394 53.0878 51.1641 52.448 51.8039Z",
    fill: "url(#paint1_linear_446_1470)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_446_1470",
    x1: 29.3241,
    y1: 1.95996,
    x2: 29.3241,
    y2: 56.2986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#342E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51539D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_446_1470",
    x1: 37.7186,
    y1: 16.793,
    x2: 37.7186,
    y2: 57.3635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#342E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51539D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnicalSupport);
export default __webpack_public_path__ + "static/media/TechnicalSupport.47e1c99eb8927b06fb068ebbc893048d.svg";
export { ForwardRef as ReactComponent };